import React, { useState, useEffect, useContext, useRef } from 'react';
import styles from './styles.module.scss';
import { Board } from '../../components/Board';
import 'moment/locale/pt';
import { DragItems, User } from '../../types';
import { DropBox } from '../../components/DropBox';
import { ComputerAndTrash } from '../../components/ComputerAndTrash';
import { CodeWithMatrix } from '../../components/CodeWithMatrix';
import { DragBox } from '../../components/DragBox';
import { MatrixBox } from '../../components/MatrixBox';
import AssetsList from '../../components/AssetsList';
import { verifyRoutePermissions } from '../../globalFunctions';
import { NavButton } from '../../components/NavButton';
import JsonCode from '../../components/JsonCode';
import Propiedades from '../../components/Propiedades';
import EditableText from '../../components/EditableText';
import { DraggableEvent } from 'react-draggable';
import { useNavigate } from 'react-router-dom';
import { Rnd } from 'react-rnd';
import { saveExercise, saveExerciseChanges } from './requestHandlers';
import { MessageContext } from '../../providers/MessageProvider';
import { YoutubeVideo } from '../../components/YoutubeVideo';
import SelectionTool from '../../components/SelectionTool';
import { Tooltip } from '../../components/ToolTip';

type DropItems = {
    id: number;
    name: string;
    type: 'checkBox' | 'varType' | 'code' | 'trash' | string;
    text?: string;
    code?: string[];
    multiple?: boolean;
    correct?: boolean;
    textLeft?: string;
    textRight?: string;
    pos: { x: number; y: number };
    scale: number;
    imagem: string;
    css?: any;
};

class BaseItem {
    id: number;
    width: number;
    height: number;
    name: string;
    type: string;
    pos: { x: number; y: number };
    scale: number;
    css: any;

    constructor(id: number, name: string, type: string, pos = { x: 0.5, y: 0.5 }, scale = 1) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.pos = pos;
        this.scale = scale;
        this.width = 0.07421875;
        this.height = 0.18153200419727178;
        this.css = {
            zIndex: 11,
            backgroundSize: '100% 100%',
            backgroundColor: 'transparent',
            borderColor: 'transparent'
        };
    }
}

class TextoItem extends BaseItem {
    text: string;
    constructor(id: number) {
        super(id, 'Texto', 'texto');
        this.text = 'Texto';
    }
}

class CampoItem extends BaseItem {
    text: string;
    css: any;
    width: number;
    height: number;
    constructor(id: number) {
        super(id, 'campo', 'dropBox');
        this.text = 'Texto';
        this.css = {
            ...this.css,
            borderWidth: '2px',
            borderStyle: 'dashed',
            zIndex: 11,
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderColor: 'rgba(0,0,0,1)'
        };
        this.width = 0.1;
        this.height = 0.1;
    }
}

class AlternativaItem extends BaseItem {
    text: string;
    css: any;
    dropAreas: string[];
    constructor(id: number) {
        super(id, 'dragbox', 'alternativa', { x: 0, y: 0 });
        this.text = 'Texto';
        this.dropAreas = [];
        this.css = {
            ...this.css,
            backgroundColor: '#54ba5e',
            color: '#000000',
            borderStyle: 'none',
            borderColor: '#ffffff',
            WebkitTextStrokeWidth: '0px',
            fontSize: '100%',
            backgroundSize: '100% 100%',
            zIndex: 11
        };
    }
}

class LixeiraItem extends BaseItem {
    constructor(id: number) {
        super(id, 'lixeira', 'trash', { x: 0, y: 0 });
    }
}

class ImagemItem extends BaseItem {
    imagem: string;
    width: number;
    height: number;
    constructor(id: number) {
        super(id, 'imagem', 'imagem', { x: 0.5, y: 0.5 });
        this.imagem = 'https://media1.tenor.com/m/WX_LDjYUrMsAAAAC/loading.gif';
        this.width = 0.1;
        this.height = 0.1;
    }
}

class VideoItem extends BaseItem {
    url: string;
    width: number;
    height: number;
    constructor(id: number) {
        super(id, 'video', 'video', { x: 0.5, y: 0.5 });
        this.url = 'https://media1.tenor.com/m/WX_LDjYUrMsAAAAC/loading.gif';
        this.width = 0.1;
        this.height = 0.1;
    }
}
type TooltipProps = {
    x: number;
    y: number;
    text: string;
    visible: boolean;
    keys?: string[];
};

export const EditorFases = () => {
    const [currentEx, setCurrentEx] = useState<number>(1);
    const [name, setName] = useState<string>(
        JSON.parse(sessionStorage.getItem('jsonEditar')!).name || 'Sem título'
    );
    const [desc, setDesc] = useState<string>(
        JSON.parse(sessionStorage.getItem('jsonEditar')!).description || 'Sem descrição'
    );
    const [dragging,setDragging] = useState<boolean>(false)
    const [viewCode, setViewCode] = useState<boolean>(false);
    const [viewProps, setViewProps] = useState<boolean>(false);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [acessivel, setAcessivel] = useState<boolean>(false);
    const [shift, setShift] = useState<boolean>(false);
    const boardRef = useRef<HTMLDivElement>(null);
    const quadroRef = useRef<HTMLDivElement>(null);
    const [userAuth, setUserAuth] = useState<User>({} as User);
    const { setOpenMessage, setMessage } = useContext(MessageContext);
    const navigate = useNavigate();
    const jsonInicial = sessionStorage.getItem('jsonEditar')
        ? JSON.parse(sessionStorage.getItem('jsonEditar')!).json
        : { dropAreas: [], steps: [] };
    const lastSave = useRef(jsonInicial);
    const [currentExJson, setCurrentExercise] = useState<any>(
        jsonInicial || { dropAreas: [], steps: [] }
    );
    const [fasePublicada, setfasePublicada] = useState<boolean>(false);
    const getComponenteById = (id: number) => {
        var componente = currentExJson.dropAreas.find(element => element.id == id);
        if (!componente) {
            componente = currentExJson.steps.find(element => element.id == id);
        }
        return componente;
    };
    const [tooltip, setTooltip] = useState<TooltipProps>({
        x: 0,
        y: 0,
        text: '',
        visible: false,
        keys: []
    });
    // ====== HISTÓRICO ROBUSTO ======
    const historyRef = useRef<any[]>([]);
    const historyIndexRef = useRef<number>(-1);
    const currentExJsonRef = useRef<any>(currentExJson); // ref sempre com o estado atual
    const commitTimerRef = useRef<number | null>(null);

    useEffect(() => {
        currentExJsonRef.current = currentExJson;
    }, [currentExJson]);

    const deepClone = (o: any) => JSON.parse(JSON.stringify(o));
    const snapshotsEqual = (a: any, b: any) => JSON.stringify(a) === JSON.stringify(b);
    const [updating, setUpdating] = useState<boolean>(false);

    const pushHistory = (snapshot: any) => {
        const snap = deepClone(snapshot);
        // evita push duplicado se igual ao último snapshot
        if (
            historyRef.current.length > 0 &&
            snapshotsEqual(historyRef.current[historyRef.current.length - 1], snap)
        ) {
            console.log('pushHistory: snapshot igual ao último — ignorando');
            return;
        }

        // corta o futuro se não estivermos no topo
        if (historyIndexRef.current < historyRef.current.length - 1) {
            console.log(
                'pushHistory: truncando futuro de',
                historyRef.current.length - 1,
                'para',
                historyIndexRef.current
            );
            historyRef.current = historyRef.current.slice(0, historyIndexRef.current + 1);
        }

        historyRef.current.push(snap);
        historyIndexRef.current = historyRef.current.length - 1;

        // limite opcional
        const MAX = 200;
        if (historyRef.current.length > MAX) {
            historyRef.current.shift();
            historyIndexRef.current = historyRef.current.length - 1;
        }

        console.log(
            'pushHistory: new length=',
            historyRef.current.length,
            'index=',
            historyIndexRef.current
        );
    };

    // força usar o ref atual no commit agendado
    const scheduleCommit = (delay = 350) => {
        if (commitTimerRef.current) window.clearTimeout(commitTimerRef.current);
        commitTimerRef.current = window.setTimeout(() => {
            pushHistory(currentExJsonRef.current);
            commitTimerRef.current = null;
        }, delay);
    };

    // applyCurrentExercise util — sempre que quiser mudar estado programaticamente
    const applyCurrentExercise = (updater: any, options: { push?: boolean } = { push: true }) => {
        if (typeof updater === 'function') {
            // usamos o updater do setState e fazemos push dentro do updater (executa com prev atual)
            setCurrentExercise(prev => {
                const next = updater(prev);
                if (options.push) pushHistory(next);
                return next;
            });
        } else {
            setCurrentExercise(updater);
            if (options.push) pushHistory(updater);
        }
    };

    function PromptTip(e: React.MouseEvent, text: string, keys: string[] = []) {
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            x: rect.left + rect.width / 2, // centraliza
            y: rect.bottom, // logo embaixo do elemento
            text: text,
            keys: keys,
            visible: true
        });
    }

    function handleMouseLeave() {
        setTooltip(t => ({ ...t, visible: false }));
    }

    const undo = () => {
        console.log('undo: index=', historyIndexRef.current, 'len=', historyRef.current.length);
        if (historyIndexRef.current > 0) {
            historyIndexRef.current -= 1;
            const snap = deepClone(historyRef.current[historyIndexRef.current]);
            setCurrentExercise(snap);
            console.log('undo -> index agora', historyIndexRef.current);
        } else {
            console.log('undo: nada para desfazer');
        }
    };

    const redo = () => {
        console.log('redo: index=', historyIndexRef.current, 'len=', historyRef.current.length);
        if (historyIndexRef.current < historyRef.current.length - 1) {
            historyIndexRef.current += 1;
            const snap = deepClone(historyRef.current[historyIndexRef.current]);
            setCurrentExercise(snap);
            console.log('redo -> index agora', historyIndexRef.current);
        } else {
            console.log('redo: nada para refazer');
        }
    };

    // inicializa o histórico com o estado inicial (garante que há pelo menos 1 snapshot)
    useEffect(() => {
        historyRef.current = [deepClone(currentExJsonRef.current)];
        historyIndexRef.current = 0;
        console.log('history inicializado. length=1 index=0');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // agora aceita MouseEvent *ou* DraggableEvent
    const SelectElement = (id: number, e: React.MouseEvent<HTMLElement> | DraggableEvent) => {
        e.stopPropagation();
        // detectar ctrl (ou cmd) como modo aditivo também
        const isCtrl = ('ctrlKey' in e && e.ctrlKey) || ('metaKey' in e && (e as any).metaKey);
        if (!isCtrl && !InSelectId(id)) {
            setSelectedIds([id]);
        } else if (isCtrl) {
            setSelectedIds(prev =>
                prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
            );
        }
    };

    const InSelectId = searchId => {
        var achou = false;
        selectedIds.forEach(id => {
            if (searchId == id) achou = true;
        });
        return achou;
    };
    const duplicate = () => {
        if (selectedIds.length === 0) return;

        applyCurrentExercise(
            prev => {
                const newJson = deepClone(prev); // use structuredClone ou JSON.parse(JSON.stringify(...))
                const newSelects: number[] = [];
                const offset = 0.05;
                selectedIds.forEach(value => {
                    const comp =
                        newJson.dropAreas.find((a: any) => a.id === value) ||
                        newJson.steps.find((s: any) => s.id === value);
                    if (!comp) return;

                    // calcula nextId com base no estado atual (newJson) para evitar colisões quando duplicar vários
                    const nextId =
                        Math.max(
                            0,
                            ...newJson.dropAreas.map((a: any) => a.id),
                            ...newJson.steps.map((s: any) => s.id)
                        ) + 1;
                    const duplicado = deepClone(comp);
                    duplicado.id = nextId;
                    duplicado.name = `${duplicado.type}${nextId}`;

                    newSelects.push(nextId);
                    setSelectedIds([nextId]);
                    duplicado.pos = {
                        x: duplicado.pos.x + offset,
                        y: duplicado.pos.y + offset
                    };

                    if (duplicado.type === 'alternativa') {
                        newJson.steps.push(duplicado);
                    } else {
                        newJson.dropAreas.push(duplicado);
                    }
                });

                // após construir newJson, atualizamos os selecionados (feita fora do setState, ver nota abaixo)
                // salvamos newSelects em uma propriedade temporária do newJson para recuperar depois
                (newJson as any).__newSelects = newSelects;
                return newJson;
            },
            { push: true }
        );

        // Atualiza selectedIds com pequeno delay para garantir que newSelects esteja disponível.
        // Se você preferir, mantenha newSelects em uma variável externa (fechadura) e atualize aqui.
        setTimeout(() => {
            // tenta ler newSelects do currentExJsonRef (se você sincroniza o ref), ou simplesmente
            // setSelectedIds(newSelects) caso você tenha newSelects em escopo acessível.
            // Exemplo simples: se tiver currentExJsonRef atualizado:
            const last = currentExJsonRef.current;
            const newSelects = last && (last as any).__newSelects ? (last as any).__newSelects : [];
            if (newSelects.length) {
                setSelectedIds(newSelects);
                // opcional: remova o campo temporário
                delete (last as any).__newSelects;
            }
        }, 50);
    };
    const deleteSelected = () => {
        if (selectedIds.length === 0) return;
        applyCurrentExercise(
            prev => ({
                dropAreas: prev.dropAreas.filter(a => !selectedIds.includes(a.id)),
                steps: prev.steps.filter(s => !selectedIds.includes(s.id))
            }),
            { push: true }
        );
        setSelectedIds([]);
    };

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            // Delete
            if (e.key === 'Delete' && selectedIds.length > 0) {
                deleteSelected();
            }

            // Shift
            if (e.key === 'Shift' && selectedIds.length > 0) {
                setShift(true);
            }

            // limpar (Ctrl+X)
            if (e.key.toLocaleLowerCase() === 'x' && (e.ctrlKey || e.metaKey)) {
                setCurrentExercise({ dropAreas: [], steps: [] });
                pushHistory({ dropAreas: [], steps: [] });
            }

            // duplicar (Ctrl+D) -> já tratado (adaptar conforme exemplo acima)
            // handler de teclas (dentro do seu useEffect)
            if (e.key.toLowerCase() === 'd' && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                duplicate();
            }

            // UNDO / REDO (suporta cmd/meta também)
            const isCmd = e.ctrlKey || e.metaKey;
            if (isCmd && e.key.toLowerCase() === 'z') {
                e.preventDefault();
                if (e.shiftKey) {
                    redo(); // ctrl+shift+z
                } else {
                    undo();
                }
            }
            if (isCmd && e.key.toLowerCase() === 'y') {
                e.preventDefault();
                redo();
            }
        };

        const handleKeyUp = (e: KeyboardEvent) => {
            if (e.key === 'Shift') {
                setShift(false);
            }
        };

        setViewProps(true);
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [selectedIds]);

    useEffect(() => {
        const user = verifyRoutePermissions(['logicmanager.classes'], navigate);

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);

    const handleUpdate = props => {
        // aplica as mudanças localmente sem empurrar no histórico imediatamente
        applyCurrentExercise(
            prev => {
                const newJson = Object.assign({}, prev);

                newJson.dropAreas.forEach(function (element, index) {
                    if (InSelectId(element.id)) {
                        for (const name in props) {
                            if (Object.prototype.hasOwnProperty.call(props, name)) {
                                if (name === 'pos') {
                                    newJson.dropAreas[index][name] = {
                                        x: newJson.dropAreas[index][name].x + props[name].x,
                                        y: newJson.dropAreas[index][name].y + props[name].y
                                    };
                                } else if (name === 'css') {
                                    newJson.dropAreas[index][name] = {
                                        ...newJson.dropAreas[index][name],
                                        ...props[name]
                                    };
                                } else {
                                    newJson.dropAreas[index][name] = props[name];
                                }
                            }
                        }
                    }
                });

                newJson.steps.forEach(function (element, index) {
                    if (InSelectId(element.id)) {
                        for (const name in props) {
                            if (Object.prototype.hasOwnProperty.call(props, name)) {
                                if (name === 'css') {
                                    newJson.steps[index][name] = {
                                        ...newJson.steps[index][name],
                                        ...props[name]
                                    };
                                } else {
                                    newJson.steps[index][name] = props[name];
                                }
                            }
                        }
                    }
                });

                return newJson;
            },
            { push: false }
        );

        // agenda o commit (snapshot final) depois que o usuário terminar a interação
        scheduleCommit();
    };

    const validateOnDrop = (items, pos) => {
        const name = items.name.toLowerCase();
        console.log(name);

        switch (name) {
            case 'lixeira':
                setCurrentExercise(prev => {
                    const nextId =
                        Math.max(
                            0,
                            ...prev.dropAreas.map(area => area.id),
                            ...prev.steps.map(area => area.id)
                        ) + 1;

                    // Calcula o próximo ID baseado no maior ID existente
                    const newLixeira = new LixeiraItem(nextId);
                    setViewProps(true);
                    setSelectedIds([nextId]);

                    return {
                        ...prev, // Mantém todas as outras propriedades
                        dropAreas: [
                            ...prev.dropAreas, // Mantém as áreas existentes
                            newLixeira
                        ]
                    };
                });
                break;
            case 'texto':
                setCurrentExercise(prev => {
                    // Calcula o próximo ID baseado no maior ID existente
                    const nextId =
                        Math.max(
                            0,
                            ...prev.dropAreas.map(area => area.id),
                            ...prev.steps.map(area => area.id)
                        ) + 1;
                    const newTexto = new TextoItem(nextId);
                    setViewProps(true);
                    setSelectedIds([nextId]);

                    return {
                        ...prev, // Mantém todas as outras propriedades
                        dropAreas: [
                            ...prev.dropAreas, // Mantém as áreas existentes
                            newTexto
                        ]
                    };
                });
                break;
            case 'alternativa':
                setCurrentExercise(prev => {
                    // Calcula o próximo ID baseado no maior ID existente
                    const nextId =
                        Math.max(
                            0,
                            ...prev.dropAreas.map(area => area.id),
                            ...prev.steps.map(area => area.id)
                        ) + 1;

                    const alternativa = new AlternativaItem(nextId);
                    setViewProps(true);
                    setSelectedIds([nextId]);
                    return {
                        ...prev,
                        steps: [...prev.steps, alternativa]
                    };
                });

                break;

            case 'campo':
                setCurrentExercise(prev => {
                    const nextId =
                        Math.max(
                            0,
                            ...prev.dropAreas.map(area => area.id),
                            ...prev.steps.map(area => area.id)
                        ) + 1;
                    // Calcula o próximo ID baseado no maior ID existente
                    const newAlternativa = new CampoItem(nextId);
                    setViewProps(true);
                    setSelectedIds([nextId]);

                    return {
                        ...prev, // Mantém todas as outras propriedades
                        dropAreas: [
                            ...prev.dropAreas, // Mantém as áreas existentes
                            newAlternativa
                        ]
                    };
                });
                break;
            case 'video':
                setCurrentExercise(prev => {
                    const nextId =
                        Math.max(
                            0,
                            ...prev.dropAreas.map(area => area.id),
                            ...prev.steps.map(area => area.id)
                        ) + 1;

                    // Calcula o próximo ID baseado no maior ID existente
                    const newVideo = new VideoItem(nextId);
                    setViewProps(true);
                    setSelectedIds([nextId]);

                    return {
                        ...prev, // Mantém todas as outras propriedades
                        dropAreas: [
                            ...prev.dropAreas, // Mantém as áreas existentes
                            newVideo
                        ]
                    };
                });
                break;
            case 'imagem':
                setCurrentExercise(prev => {
                    const nextId =
                        Math.max(
                            0,
                            ...prev.dropAreas.map(area => area.id),
                            ...prev.steps.map(area => area.id)
                        ) + 1;

                    // Calcula o próximo ID baseado no maior ID existente
                    const newImagem = new ImagemItem(nextId);
                    setViewProps(true);
                    setSelectedIds([nextId]);

                    return {
                        ...prev, // Mantém todas as outras propriedades
                        dropAreas: [
                            ...prev.dropAreas, // Mantém as áreas existentes
                            newImagem
                        ]
                    };
                });
                break;
        }
    };

    const copiar = async () => {
        try {
            await navigator.clipboard.writeText(JSON.stringify(currentExJson));
        } catch (err) {
            alert('Erro ao copiar: ' + err);
        }
    };

    const tratarErros = (dropArea: any) => {
        var newDropArea = dropArea;
        if (newDropArea.css) {
            if (!newDropArea.css.zIndex || newDropArea.css.zIndex <= 0) {
                newDropArea.css.zIndex = 1;
            }
        } else {
            newDropArea.css = { zIndex: 1 };
        }
        if (!newDropArea.pos) {
            newDropArea.pos = { x: 0.5, y: 0.5 };
        }
        if (!newDropArea.type) {
            newDropArea.type = 'alternativa';
        }

        //  newDropArea.id = nextId

        return newDropArea;
    };

    const renderDropBox = (dropArea: any) => {
        console.log(dropArea.type);
        const key = dropArea.id;
        const getElement = getComponenteById(dropArea.id);
        const width = window.innerWidth ?? 0;
        const height = window.innerHeight ?? 0;
        const isSelected = selectedIds.includes(dropArea.id);

        // — 2) converte proporção em pixel
        const xPx = (dropArea.pos?.x ?? 0) * width;
        const yPx = (dropArea.pos?.y ?? 0) * height;

        if (getElement) {
            dropArea = getElement;
        }

        dropArea = tratarErros(dropArea);

        switch (dropArea.type) {
            case 'trash':
                return (
                    <Rnd
                        minWidth={100}
                        minHeight={100}
                        maxWidth={300}
                        maxHeight={300}
                        className={`componente ${isSelected ? styles.selected : ''}`}
                        style={{ zIndex: 11 + dropArea.css.zIndex }}
                        lockAspectRatio={true}
                        size={{ width: dropArea.width * width, height: dropArea.height * height }}
                        position={{ x: dropArea.pos.x * width, y: dropArea.pos.y * height }}
                        onDragStart={e => SelectElement(dropArea.id, e)}
                        data-id={dropArea.id.toString()}
                        onDrag={(e, d) => {
                            const xRatio = d.x / width;
                            const yRatio = d.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            // salva a posição final absoluta (use applyCurrentExercise para empurrar history)
                            applyCurrentExercise(
                                prev => {
                                    const newJson = deepClone(prev);
                                    // encontra e atualiza dropArea correspondente (exemplo para dropAreas)
                                    const idx = newJson.dropAreas.findIndex(
                                        a => a.id === dropArea.id
                                    );

                                    newJson.dropAreas.forEach(function (element, index) {
                                        if (InSelectId(element.id)) {
                                            newJson.dropAreas[index].pos = {
                                                x: newJson.dropAreas[index].pos.x + Xdif,
                                                y: newJson.dropAreas[index].pos.y + Ydif
                                            };
                                        }
                                    });

                                    return newJson;
                                },
                                { push: false }
                            );
                        }}
                        onDragStop={(e, d) => {
                            const xRatio = d.x / width;
                            const yRatio = d.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            // salva a posição final absoluta (use applyCurrentExercise para empurrar history)
                            applyCurrentExercise(
                                prev => {
                                    const newJson = deepClone(prev);
                                    // encontra e atualiza dropArea correspondente (exemplo para dropAreas)
                                    const idx = newJson.dropAreas.findIndex(
                                        a => a.id === dropArea.id
                                    );

                                    newJson.dropAreas.forEach(function (element, index) {
                                        if (InSelectId(element.id)) {
                                            newJson.dropAreas[index].pos = {
                                                x: newJson.dropAreas[index].pos.x + Xdif,
                                                y: newJson.dropAreas[index].pos.y + Ydif
                                            };
                                        }
                                    });

                                    return newJson;
                                },
                                { push: true }
                            );
                        }}
                        id={key}
                        onResize={(e, direction, ref, delta, position) => {
                            const xRatio = position.x / width;
                            const yRatio = position.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            const wRatio = parseFloat(ref.style.width) / width;
                            const hRatio = parseFloat(ref.style.height) / height;
                            handleUpdate({
                                width: wRatio,
                                height: hRatio,
                                pos: { x: Xdif, y: Ydif }
                            });
                        }}
                    >
                        <ComputerAndTrash
                            css={dropArea.css}
                            type={dropArea.type}
                            name={dropArea.name}
                            pos={{ x: 0, y: 0 }}
                            size={{}}
                            component={'trash'}
                            validateOnDrop={validateOnDrop}
                            scale={dropArea.scale}
                            isLogicMaker={true}
                        />
                    </Rnd>
                );

            case 'alternativa':
                return (
                    <Rnd
                        className={`componente ${styles.box} ${styles.alternativa} ${
                            styles.boxDrag
                        } ${styles.boxDragLevel} dragBoxItem ${isSelected ? styles.selected : ''} ${
                            shift ? styles.shift : ''
                        }`}
                        data-id={dropArea.id.toString()}
                        bounds='window'
                        size={{ width: dropArea.width * width, height: dropArea.height * height }}
                        minWidth={50}
                        minHeight={30}
                        maxWidth={2000}
                        maxHeight={2000}
                        lockAspectRatio={shift} // ajuste se quiser travar proporção com Shift
                        onDragStart={e => SelectElement(dropArea.id, e)}
                        onResize={(e, direction, ref, delta, position) => {
                            const xRatio = position.x / width;
                            const yRatio = position.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            const wRatio = parseFloat(ref.style.width) / width;
                            const hRatio = parseFloat(ref.style.height) / height;

                            handleUpdate({
                                width: wRatio,
                                height: hRatio
                            });
                        }}
                        style={{ zIndex: 11 + dropArea.css.zIndex }}
                    >
                        <DragBox
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: dropArea.css?.alignItems ?? undefined,
                                justifyContent: dropArea.css?.justifyContent ?? undefined,
                                ...dropArea.css,
                                backgroundImage: acessivel
                                    ? dropArea.css.backgroundImage
                                    : `url(${dropArea.imagem})`,
                                backgroundSize: '100% 100%'
                            }}
                            key={key}
                            data-id={dropArea.id.toString()}
                            className={`componente-inner dragBoxItem-inner`}
                            draggable={false}
                            hideOnDrag={true}
                            isLogicMaker={true}
                            onMouseDown={e => {
                                e.stopPropagation();
                                SelectElement(dropArea.id, e);
                            }}
                            items={
                                {
                                    id: dropArea.id,
                                    validDrops: []
                                } as DragItems
                            }
                        >
                            <EditableText
                                texto={(!acessivel && dropArea.text) || ''}
                                onSave={newText => handleUpdate({ text: newText })}
                                isLogicMaker={true}
                            />
                        </DragBox>
                    </Rnd>
                );

            case 'texto':
                return (
                    <>
                        <Rnd
                            bounds='window'
                            className={`componente ${isSelected ? styles.selected : ''}  ${
                                shift ? styles.shift : ''
                            }`}
                            id={dropArea.id}
                            lockAspectRatio={shift}
                            minWidth={50}
                            minHeight={50}
                            maxWidth={1000}
                            maxHeight={1000}
                            data-id={dropArea.id.toString()}
                            size={{
                                width: dropArea.width * width,
                                height: dropArea.height * height
                            }}
                            onDragStart={e => SelectElement(key, e)}
                            position={{ x: xPx, y: yPx }}
                            style={{ zIndex: 11 + dropArea.css.zIndex }}
                            onDrag={(e, d) => {
                                const xRatio = d.x / width;
                                const yRatio = d.y / height;
                                const Xdif = xRatio - dropArea.pos.x;
                                const Ydif = yRatio - dropArea.pos.y;
                                // salva a posição final absoluta (use applyCurrentExercise para empurrar history)
                                applyCurrentExercise(
                                    prev => {
                                        const newJson = deepClone(prev);
                                        // encontra e atualiza dropArea correspondente (exemplo para dropAreas)
                                        const idx = newJson.dropAreas.findIndex(
                                            a => a.id === dropArea.id
                                        );

                                        newJson.dropAreas.forEach(function (element, index) {
                                            if (InSelectId(element.id)) {
                                                newJson.dropAreas[index].pos = {
                                                    x: newJson.dropAreas[index].pos.x + Xdif,
                                                    y: newJson.dropAreas[index].pos.y + Ydif
                                                };
                                            }
                                        });

                                        return newJson;
                                    },
                                    { push: false }
                                );
                            }}
                            onDragStop={(e, d) => {
                                const xRatio = d.x / width;
                                const yRatio = d.y / height;
                                const Xdif = xRatio - dropArea.pos.x;
                                const Ydif = yRatio - dropArea.pos.y;
                                // salva a posição final absoluta (use applyCurrentExercise para empurrar history)
                                applyCurrentExercise(
                                    prev => {
                                        const newJson = deepClone(prev);
                                        // encontra e atualiza dropArea correspondente (exemplo para dropAreas)
                                        const idx = newJson.dropAreas.findIndex(
                                            a => a.id === dropArea.id
                                        );

                                        newJson.dropAreas.forEach(function (element, index) {
                                            if (InSelectId(element.id)) {
                                                newJson.dropAreas[index].pos = {
                                                    x: newJson.dropAreas[index].pos.x + Xdif,
                                                    y: newJson.dropAreas[index].pos.y + Ydif
                                                };
                                            }
                                        });

                                        return newJson;
                                    },
                                    { push: true }
                                );
                            }}
                            onResize={(e, direction, ref, delta, position) => {
                                const xRatio = position.x / width;
                                const yRatio = position.y / height;
                                const Xdif = xRatio - dropArea.pos.x;
                                const Ydif = yRatio - dropArea.pos.y;
                                const wRatio = parseFloat(ref.style.width) / width;
                                const hRatio = parseFloat(ref.style.height) / height;
                                handleUpdate({
                                    width: wRatio,
                                    height: hRatio,
                                    pos: { x: Xdif, y: Ydif }
                                });
                            }}
                        >
                            <EditableText
                                css={dropArea.css}
                                texto={dropArea.text || ''}
                                onSave={newText => handleUpdate({ text: newText })}
                                onClick={e => SelectElement(dropArea.id, e)}
                                isLogicMaker={true}
                            />
                        </Rnd>
                    </>
                );

            case 'dropBox':
                return (
                    <Rnd
                        size={{ width: dropArea.width * width, height: dropArea.height * height }}
                        style={{ zIndex: 11 + dropArea.css ? dropArea.css.zIndex : 0 }}
                        className={`componente ${isSelected ? styles.selected : ''}  ${
                            shift ? styles.shift : ''
                        }`}
                        onDragStart={(e, data) => SelectElement(key, e)}
                        lockAspectRatio={shift}
                        data-id={dropArea.id.toString()}
                        position={{ x: dropArea.pos.x * width, y: dropArea.pos.y * height }}
                        onDrag={(e, d) => {
                            const xRatio = d.x / width;
                            const yRatio = d.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            // salva a posição final absoluta (use applyCurrentExercise para empurrar history)
                            applyCurrentExercise(
                                prev => {
                                    const newJson = deepClone(prev);
                                    // encontra e atualiza dropArea correspondente (exemplo para dropAreas)
                                    const idx = newJson.dropAreas.findIndex(
                                        a => a.id === dropArea.id
                                    );

                                    newJson.dropAreas.forEach(function (element, index) {
                                        if (InSelectId(element.id)) {
                                            newJson.dropAreas[index].pos = {
                                                x: newJson.dropAreas[index].pos.x + Xdif,
                                                y: newJson.dropAreas[index].pos.y + Ydif
                                            };
                                        }
                                    });

                                    return newJson;
                                },
                                { push: false }
                            );
                        }}
                        onDragStop={(e, d) => {
                            const xRatio = d.x / width;
                            const yRatio = d.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            // salva a posição final absoluta (use applyCurrentExercise para empurrar history)
                            applyCurrentExercise(
                                prev => {
                                    const newJson = deepClone(prev);
                                    // encontra e atualiza dropArea correspondente (exemplo para dropAreas)
                                    const idx = newJson.dropAreas.findIndex(
                                        a => a.id === dropArea.id
                                    );

                                    newJson.dropAreas.forEach(function (element, index) {
                                        if (InSelectId(element.id)) {
                                            newJson.dropAreas[index].pos = {
                                                x: newJson.dropAreas[index].pos.x + Xdif,
                                                y: newJson.dropAreas[index].pos.y + Ydif
                                            };
                                        }
                                    });

                                    return newJson;
                                },
                                { push: true }
                            );
                        }}
                        onResize={(e, direction, ref, delta, position) => {
                            const xRatio = position.x / width;
                            const yRatio = position.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            const wRatio = parseFloat(ref.style.width) / width;
                            const hRatio = parseFloat(ref.style.height) / height;
                            handleUpdate({
                                width: wRatio,
                                height: hRatio,
                                pos: { x: Xdif, y: Ydif }
                            });
                        }}
                    >
                        <DropBox
                            id={key.toString()}
                            key={key}
                            className={`${styles.box} ${styles.boxDrop}`}
                            items={{ id: dropArea.id, name: dropArea.name } as DropItems}
                            onDrop={validateOnDrop}
                            onClick={e => {
                                SelectElement(dropArea.id, e);
                            }}
                            css={dropArea.css}
                            isLogicMaker={true}
                        >
                            <EditableText
                                texto={dropArea.text || ''}
                                id={dropArea.id.toString()}
                                onSave={newText => handleUpdate({ text: newText })}
                                onClick={e => SelectElement(dropArea.id, e)}
                                isLogicMaker={true}
                            />
                        </DropBox>
                    </Rnd>
                );
            case 'video':
                return (
                    <Rnd
                        className={`componente ${isSelected ? styles.selected : ''} ${
                            shift ? styles.shift : ''
                        }`}
                        size={{ width: dropArea.width * width, height: dropArea.height * height }}
                        style={{ zIndex: 11 + dropArea.css.zIndex }}
                        lockAspectRatio={shift}
                        data-id={dropArea.id.toString()}
                        onDragStart={(e, data) => {
                            SelectElement(key, e)
                            setDragging(true)
                        }}
                        position={{ x: dropArea.pos.x * width, y: dropArea.pos.y * height }}
                        onDrag={(e, d) => {
                            const xRatio = d.x / width;
                            const yRatio = d.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            // salva a posição final absoluta (use applyCurrentExercise para empurrar history)
                            applyCurrentExercise(
                                prev => {
                                    const newJson = deepClone(prev);
                                    // encontra e atualiza dropArea correspondente (exemplo para dropAreas)
                                    const idx = newJson.dropAreas.findIndex(
                                        a => a.id === dropArea.id
                                    );

                                    newJson.dropAreas.forEach(function (element, index) {
                                        if (InSelectId(element.id)) {
                                            newJson.dropAreas[index].pos = {
                                                x: newJson.dropAreas[index].pos.x + Xdif,
                                                y: newJson.dropAreas[index].pos.y + Ydif
                                            };
                                        }
                                    });

                                    return newJson;
                                },
                                { push: false }
                            );
                        }}
                        onDragStop={(e, d) => {
                            const xRatio = d.x / width;
                            const yRatio = d.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            setDragging(false)

                            // salva a posição final absoluta (use applyCurrentExercise para empurrar history)
                            applyCurrentExercise(
                                prev => {
                                    const newJson = deepClone(prev);
                                    // encontra e atualiza dropArea correspondente (exemplo para dropAreas)
                                    const idx = newJson.dropAreas.findIndex(
                                        a => a.id === dropArea.id
                                    );

                                    newJson.dropAreas.forEach(function (element, index) {
                                        if (InSelectId(element.id)) {
                                            newJson.dropAreas[index].pos = {
                                                x: newJson.dropAreas[index].pos.x + Xdif,
                                                y: newJson.dropAreas[index].pos.y + Ydif
                                            };
                                        }
                                    });

                                    return newJson;
                                },
                                { push: true }
                            );
                        }}
                        onResize={(e, direction, ref, delta, position) => {
                            const xRatio = position.x / width;
                            const yRatio = position.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            const wRatio = parseFloat(ref.style.width) / width;
                            const hRatio = parseFloat(ref.style.height) / height;
                            handleUpdate({
                                width: wRatio,
                                height: hRatio,
                                pos: { x: Xdif, y: Ydif }
                            });
                        }}
                    >
                        <YoutubeVideo
                            isLogicMaker={true}
                            onClick={(e: any) => {
                                alert('selecionei');
                                SelectElement(dropArea.id, e);
                            }}
                            id={key.toString()}
                            isDragging={dragging}
                            videoUrl={dropArea.url}
                        />
                    </Rnd>
                );

            case 'imagem':
                return (
                    <Rnd
                        className={`${isSelected ? styles.selected : ''} ${
                            shift ? styles.shift : ''
                        }`}
                        size={{ width: dropArea.width * width, height: dropArea.height * height }}
                        style={{ zIndex: 11 + dropArea.css.zIndex }}
                        data-id={dropArea.id.toString()}
                        onDragStart={(e, d) => {
                            SelectElement(key, e);
                            // salvar ponto inicial (opcional para undo)
                            pushHistory(currentExJsonRef.current);
                        }}
                        lockAspectRatio={shift}
                        position={{ x: dropArea.pos.x * width, y: dropArea.pos.y * height }}
                        onDrag={(e, d) => {
                            const xRatio = d.x / width;
                            const yRatio = d.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            // salva a posição final absoluta (use applyCurrentExercise para empurrar history)
                            applyCurrentExercise(
                                prev => {
                                    const newJson = deepClone(prev);
                                    // encontra e atualiza dropArea correspondente (exemplo para dropAreas)
                                    const idx = newJson.dropAreas.findIndex(
                                        a => a.id === dropArea.id
                                    );

                                    newJson.dropAreas.forEach(function (element, index) {
                                        if (InSelectId(element.id)) {
                                            newJson.dropAreas[index].pos = {
                                                x: newJson.dropAreas[index].pos.x + Xdif,
                                                y: newJson.dropAreas[index].pos.y + Ydif
                                            };
                                        }
                                    });

                                    return newJson;
                                },
                                { push: false }
                            );
                        }}
                        onDragStop={(e, d) => {
                            const xRatio = d.x / width;
                            const yRatio = d.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            // salva a posição final absoluta (use applyCurrentExercise para empurrar history)
                            applyCurrentExercise(
                                prev => {
                                    const newJson = deepClone(prev);
                                    // encontra e atualiza dropArea correspondente (exemplo para dropAreas)
                                    const idx = newJson.dropAreas.findIndex(
                                        a => a.id === dropArea.id
                                    );

                                    newJson.dropAreas.forEach(function (element, index) {
                                        if (InSelectId(element.id)) {
                                            newJson.dropAreas[index].pos = {
                                                x: newJson.dropAreas[index].pos.x + Xdif,
                                                y: newJson.dropAreas[index].pos.y + Ydif
                                            };
                                        }
                                    });

                                    return newJson;
                                },
                                { push: true }
                            );
                        }}
                        onResize={(e, direction, ref, delta, position) => {
                            const xRatio = position.x / width;
                            const yRatio = position.y / height;
                            const Xdif = xRatio - dropArea.pos.x;
                            const Ydif = yRatio - dropArea.pos.y;
                            const wRatio = parseFloat(ref.style.width) / width;
                            const hRatio = parseFloat(ref.style.height) / height;
                            handleUpdate({
                                width: wRatio,
                                height: hRatio,
                                pos: { x: Xdif, y: Ydif }
                            });
                        }}
                    >
                        <img
                            className='componente'
                            src={
                                dropArea.imagem !== ''
                                    ? dropArea.imagem
                                    : 'https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca.gif'
                            }
                            alt={dropArea.text}
                            style={{ height: '100%', width: '100%', margin: 0, ...dropArea.css }}
                            draggable={false}
                            data-id={dropArea.id.toString()}
                        />
                    </Rnd>
                );

            default:
                return <></>;
        }
    };

    const renderTemplateBoxes = () => {
        let content: JSX.Element[] = [];
        console.log(sessionStorage.getItem('jsonEditar'));

        if (currentExJson.layout) {
            content.push(
                <MatrixBox
                    layout={currentExJson.layout}
                    dropAreas={currentExJson.dropAreas ? currentExJson.dropAreas : []}
                    validateOnDrop={validateOnDrop}
                    currentEx={currentEx}
                    show={currentEx != 1}
                />
            );
        }

        if (currentExJson.pseudocode && currentExJson.matrix) {
            content.push(
                <CodeWithMatrix
                    className={styles.longArray}
                    pseudocode={currentExJson.pseudocode}
                    matrix={currentExJson.matrix}
                    validateOnDrop={validateOnDrop}
                    currentEx={currentEx}
                    show={true}
                />
            );
        }

        if (currentExJson.dropAreas) {
            currentExJson.dropAreas.forEach(dropArea => {
                content.push(renderDropBox(dropArea));
            });
            currentExJson.steps.forEach(dropArea => {
                // content.push(renderDropBox(dropArea));
            });
        }
        return <>{content}</>;
    };

    function isSaved() {
        return JSON.stringify(lastSave.current) === JSON.stringify(currentExJson);
    }

    const renderResponseBoxes = () => {
        let content: any[] = [];
        currentExJson.steps.forEach(step => {
            console.log(step);
            content.push(renderDropBox(step));
        });
        return <>{content}</>;
    };

    const createExercise = async () => {
        const moduleId = sessionStorage.getItem('moduleId') || 1;
        setUpdating(true);
        const success = await saveExercise(
            userAuth.token,
            {
                FK_module_id: moduleId,
                json: JSON.stringify(currentExJson),
                description: desc,
                name: name,
                is_active: false
            },
            navigate
        );
        console.log(success);
        if (success) {
            setTimeout(() => {
                navigate('/manager/LogicMaker');
            }, 1000);
            setfasePublicada(true);
            setOpenMessage(true);
            setMessage({
                type: 'success',
                content: 'Exercicio criado com sucesso'
            });
        } else {
            setOpenMessage(true);
            setMessage({
                type: 'error',
                content: 'Erro ao criar exercicio'
            });
        }
        setUpdating(false);
    };

    const resetExercise = () => {
        setCurrentExercise(jsonInicial);
        pushHistory(jsonInicial);
    };

    const updateExercise = async () => {
        setUpdating(true);
        const success = await saveExerciseChanges(
            userAuth.token,
            {
                ...JSON.parse(sessionStorage.getItem('jsonEditar')!),
                name: name,
                json: JSON.stringify(currentExJson),
                description: desc
            },
            navigate
        );
        if (success) {
            setOpenMessage(true);
            setMessage({
                type: 'success',
                content: 'Exercicio editado com sucesso'
            });
            lastSave.current = currentExJson;
            sessionStorage.setItem(
                'jsonEditar',
                JSON.stringify({
                    ...JSON.parse(sessionStorage.getItem('jsonEditar') || ''),
                    json: currentExJson,
                    description: desc,
                    name: name
                })
            );
        } else {
            setOpenMessage(true);
            setMessage({
                type: 'error',
                content: 'Erro ao editar exercicio'
            });
        }
        setUpdating(false);
    };
    const options =
        currentExJson &&
        currentExJson.dropAreas.map(d => ({
            value: d.name,
            label: d.name
        }));
    return (
        <div className={styles.wrapper} ref={boardRef}>
            {renderTemplateBoxes()}
            <nav className={styles.navbar}>
                <span
                    className={`${styles.home} material-symbols-sharp`}
                    onMouseEnter={e => {
                        PromptTip(e, 'Voltar');
                    }}
                    style={{ cursor: 'pointer' }}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => navigate('/manager/LogicMaker')}
                >
                    menu
                </span>
                <button
                    disabled={historyIndexRef.current == 0}
                    onClick={undo}
                    className={styles.barButton}
                >
                    <span
                        className='material-symbols-outlined'
                        onMouseEnter={e => {
                            PromptTip(e, 'Desfazer', ['Ctrl', 'Z']);
                        }}
                        onMouseLeave={handleMouseLeave}
                    >
                        undo
                    </span>
                </button>
                <button
                    disabled={historyIndexRef.current >= historyRef.current.length - 1}
                    onClick={redo}
                    className={styles.barButton}
                >
                    <span
                        className='material-symbols-outlined'
                        onMouseEnter={e => {
                            PromptTip(e, 'Refazer', ['Ctrl', 'Y']);
                        }}
                        onMouseLeave={handleMouseLeave}
                    >
                        redo
                    </span>
                </button>
                <button
                    disabled={selectedIds.length == 0}
                    onClick={duplicate}
                    className={styles.barButton}
                >
                    <span
                        className='material-symbols-outlined'
                        onMouseEnter={e => {
                            PromptTip(e, 'Duplicar', ['Ctrl', 'D']);
                        }}
                        onMouseLeave={handleMouseLeave}
                    >
                        file_copy
                    </span>
                </button>
                <button
                    disabled={selectedIds.length == 0}
                    onClick={deleteSelected}
                    className={styles.barButton}
                >
                    <span
                        className='material-symbols-outlined'
                        onMouseEnter={e => {
                            PromptTip(e, 'Deletar', ['Delete']);
                        }}
                        onMouseLeave={handleMouseLeave}
                    >
                        delete
                    </span>
                </button>
                <button
                    onClick={() => {
                        setAcessivel(prev => !prev);
                    }}
                    className={styles.barButton}
                >
                    <span
                        className={`material-symbols-outlined ${styles.acessibilidade} ${
                            acessivel ? styles.acessibilidadeAtivo : ''
                        }`}
                        onMouseEnter={e => {
                            PromptTip(e, 'Modo acessibilidade');
                        }}
                        onMouseLeave={handleMouseLeave}
                    >
                        accessibility
                    </span>
                </button>
                <EditableText
                    onSave={newText => setName(newText)}
                    css={{ width: '30vw', height: '100%', margin: 'auto' }}
                    texto={name}
                    isLogicMaker={true}
                />
                <span
                    onMouseEnter={e => {
                        PromptTip(e, isSaved() ? 'Salvo' : 'Não salvo');
                    }}
                    onMouseLeave={handleMouseLeave}
                >
                    {isSaved() &&
                    name == JSON.parse(sessionStorage.getItem('jsonEditar')!).name &&
                    desc == JSON.parse(sessionStorage.getItem('jsonEditar')!).description
                        ? '✅'
                        : '❌'}
                </span>
                {sessionStorage.getItem('action') == 'edit' ? (
                    <>
                        <button className={styles.updateExercise} onClick={updateExercise}>
                            {updating ? (
                                <span className={styles.loader}></span>
                            ) : (
                                'Salvar alterações'
                            )}
                        </button>
                        <button className={styles.resetExercise} onClick={resetExercise}>
                            Desfazer todas as alterações
                        </button>
                    </>
                ) : (
                    !fasePublicada && (
                        <button className={styles.updateExercise} onClick={createExercise}>
                            {updating ? <span className={styles.loader}></span> : 'Criar fase'}
                        </button>
                    )
                )}
            </nav>
            <AssetsList />
            {viewProps && selectedIds.length > 0 && (
                <Propiedades
                    options={options}
                    selected={
                        selectedIds.length < 2
                            ? getComponenteById(selectedIds[selectedIds.length - 1])
                            : selectedIds
                    }
                    onTextChange={handleUpdate}
                    deleteSelected={deleteSelected}
                />
            )}

            <Board wrapperClass={styles.board} ref={quadroRef}>
                <SelectionTool
                    boardRef={quadroRef}
                    paginaRef={boardRef}
                    selectableSelector={'.componente'}
                    onSelectionChange={ids => setSelectedIds(ids.map(id => parseInt(id, 10)))}
                />

                <div className={styles.boardInner} onClick={() => setSelectedIds([])}>
                    <DropBox
                        type={'asset'}
                        key={'quadroHitBox'}
                        className={`${styles.box} ${styles.hitboxQuadro}`}
                        items={{ id: 666, name: 'quadroHitBox' } as DropItems}
                        onDrop={validateOnDrop}
                    >
                        <div className={styles.exTrackerWrapper}></div>
                        <div className={`${styles.main} ${styles.mainLeft}`}></div>
                        <div className={`${styles.main} ${styles.mainRight} dragBoxContainer`}>
                            {renderResponseBoxes()}
                        </div>
                    </DropBox>
                </div>
            </Board>

            <NavButton
                title='Ver Código'
                icon='code'
                style={{
                    position: 'absolute',
                    transition: '.5s',
                    right: '17vw',
                    bottom: '1vw',
                    transform: 'scale(1.5)'
                }}
                onClick={() => setViewCode(!viewCode)}
            />

            <div
                style={{
                    width: '70vw',
                    height: '20vh',
                    outline: 'solid green 5px',
                    background: 'white',
                    position: 'absolute',
                    bottom: '6vw'
                }}
            >
                <EditableText isLogicMaker={true} onSave={setDesc} texto={desc} />
            </div>
            {viewCode && <JsonCode copiar={copiar} code={JSON.stringify(currentExJson, null, 2)} />}
            <Tooltip
                x={tooltip.x}
                y={tooltip.y}
                text={tooltip.text}
                visible={tooltip.visible}
                keys={tooltip.keys}
            />
        </div>
    );
};
